module.exports = __webpack_public_path__ + "media/src/images/icons/gear-9d833ba734ae94cd26821f82cdb939b0.svg";